import {
  Accordion,
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  Group,
  Stack,
  Text,
} from "@assetwatch/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useCmmsVendors } from "../queries/useCmmsVendors";
import { CmmsIntegrationPanel } from "./CmmsIntegrationPanel";

/**
 * "Integrations" accordion for the Marketplace home page, matching the Toolbox
 * prototype's Integrations grouping and sitting below the subscriptions /
 * available-capabilities accordions.
 *
 * The setup flow opens in a right-side drawer, as the prototype does
 * (`drawer-scrim--right` in integration.jsx) rather than expanding inline.
 *
 * The vendor query is shared with the /capabilities/cmms-integration route via
 * cmmsVendorsQueryOptions, so opening this costs no extra request once either
 * has loaded.
 */
export function CmmsIntegrationAccordion() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { data } = useCmmsVendors();
  const vendorCount = data?.vendors.length ?? 0;

  return (
    <Accordion
      defaultOpen
      title={t("marketplace.cmms.accordionTitle")}
      titleAccessory={
        <Text size="sm" tone="subtle">
          {vendorCount > 0
            ? t("marketplace.cmms.vendorsAvailable", { count: vendorCount })
            : t("marketplace.cmms.accordionSubtitle")}
        </Text>
      }
    >
      <Stack gap={16}>
        <Text tone="subtle">{t("marketplace.cmms.accordionDescription")}</Text>
        <Group gap={12} wrap="wrap">
          <Button
            icon="settings-cog"
            onClick={() => setOpen(true)}
            variant="primary"
          >
            {t("marketplace.cmms.setUpIntegration")}
          </Button>
        </Group>
      </Stack>

      <Drawer onOpenChange={setOpen} open={open}>
        <DrawerContent>
          <DrawerHeader
            leadingIcon="settings-cog"
            subtitle={t("marketplace.cmms.drawerSubtitle")}
            title={t("marketplace.cmms.title")}
          />
          <DrawerBody>
            <CmmsIntegrationPanel />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Accordion>
  );
}
